<template>
  <div class="banner">
    <img src="../assets/banner.png" alt="">
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data () {
    return {
    }
  },
  watch: {},
  computed: {},
  methods: {},
  created () {},
  mounted () {}
}
</script>
<style scoped>
.banner {
  width: 100%;
  /* padding-bottom: 42%; */
}
.banner img {
  width: 100%;
}
</style>